import { environmentConfig } from "@/shared/environment/config";

/**
 * Browser → FlowOps origin (old FE talks to these same `/api/*` mutation/SSE routes).
 * Avoids a second Next rewrite/proxy hop on the new FE.
 */
export function flowopsApiUrl(path: string): string {
  const base = environmentConfig.BACKEND_API_URL.replace(/\/$/, "");
  if (!path) return base || "";
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (!base) return normalized;
  return `${base}${normalized}`;
}

/** Same as `fetch`, but relative `/api/...` paths hit FlowOps directly. */
export function flowopsFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (typeof input === "string") {
    return fetch(flowopsApiUrl(input), init);
  }
  if (input instanceof URL) {
    return fetch(flowopsApiUrl(`${input.pathname}${input.search}`), init);
  }
  return fetch(input, init);
}
